import React from 'react';
import { Typography } from "@material-tailwind/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { PlusCircleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Field } from 'formik';

export const TabMinistrosDependientes = (props) => {
    const { 
        values, handleChange, setFieldValue, esVisualizacion,
        balances, handleEliminarBalance,
        nuevoBalancePeriodo, setNuevoBalancePeriodo, nuevoBalanceFecha, setNuevoBalanceFecha, handleAgregarBalance,
        diezmos,
        nuevoMinistroSeleccionado, setNuevoMinistroSeleccionado, obrerosUad, handleAgregarMinistroInfo, ministrosDependientes, handleEliminarMinistroInfo,
        cuentasBancarias, setCuentaActiva, cuentaActiva, handleEliminarCuentaBancaria, bancosList, tiposCuentasList, handleGuardarCuentaBancaria, handleFirmanteChange
    } = props;

    return (

        <div className="bg-white p-5 rounded-md">
             <Typography variant="small" color="blue-gray" className="mb-4 font-medium">Ministros dependientes ({ministrosDependientes?.length || 0})</Typography>
             
             <div className="flex flex-col md:flex-row gap-6 items-start">
                 {/* Left side: List box */}
                 <div className="flex flex-col border border-gray-300 w-full md:w-[500px] h-[300px] bg-white shadow-sm">
                     {/* <div className="bg-gray-100 border-b border-gray-300 px-3 py-2 text-xs font-semibold text-gray-700">
                         Ministros dependientes
                     </div> */}
                     <ul className="flex-1 overflow-y-auto no-scrollbar">
                         {ministrosDependientes && ministrosDependientes.length > 0 ? (
                             ministrosDependientes.map((m, idx) => (
                                 <li 
                                    key={idx} 
                                    className="px-3 py-2 text-sm border-b border-gray-100 last:border-0 hover:bg-gray-50 flex justify-between items-center text-gray-800"
                                 >
                                     <span>{m.nombre || m.nombre_obrero || m.apellidos_nombres || m.obrero || `Ministro #${m.id_ministro || m.id_obrero}`} {detallesDep(m)}</span>
                                     {!esVisualizacion && (
                                        <button 
                                            type="button"
                                            title="Desvincular ministro"
                                            onClick={(e) => { e.stopPropagation(); handleEliminarMinistroInfo(m.id_ministro || m.id_obrero); }}
                                            className="text-red-500 hover:text-red-700 hover:bg-red-50 p-2 rounded transition-colors"
                                        >
                                            <TrashIcon width={20} height={20} />
                                        </button>
                                     )}
                                 </li>
                             ))
                         ) : (
                             <div className="p-3 text-gray-500 text-xs text-center italic mt-10">No hay ministros asignados</div>
                         )}
                     </ul>
                 </div>

                 {/* Right side: Add user */}
                 <div className="flex flex-col items-start gap-4 mt-2 md:mt-0 w-full md:w-auto">
                     {!esVisualizacion && <div className="flex flex-col items-start gap-2 bg-gray-50 p-4 border border-gray-200 shadow-sm rounded-md w-full">
                         <span className="text-xs font-semibold text-gray-600 mb-1">Vincular nuevo ministro dependiente:</span>
                         <div className="flex flex-row items-center gap-2 w-full">
                             <div className="w-full md:w-[350px]">
                                 <select 
                                    className="iglesia-form-control"
                                    value={nuevoMinistroSeleccionado}
                                    onChange={(e) => setNuevoMinistroSeleccionado(e.target.value)}
                                    disabled={esVisualizacion}
                                 >
                                     <option value="">Seleccione un ministro...</option>
                                     {obrerosUad && obrerosUad.map((o, idx) => (
                                         <option key={o.id_obrero || idx} value={o.id_obrero}>{o.obrero || o.apellidos_nombres}</option>
                                     ))}
                                 </select>
                             </div>
                             <button 
                                 type="button" 
                                 title="Agregar ministro"
                                 onClick={handleAgregarMinistroInfo}
                                 disabled={esVisualizacion || !nuevoMinistroSeleccionado}
                                 className={`h-[42px] transition-transform hover:scale-110 flex items-center justify-center px-3 ${( !nuevoMinistroSeleccionado || esVisualizacion) ? 'opacity-50 cursor-not-allowed grayscale' : 'cursor-pointer hover:bg-green-100 rounded-md'}`}
                             >
                                 <span className="px-3 font-bold uppercase">Agregar</span>
                             </button>
                         </div>
                     </div>}
                 </div>
             </div>

        </div>
    
    );
};


const detallesDep = (dependiente)=>{

    return dependiente?.rango || dependiente?.ministerio ? ` - ${dependiente?.rango || ''} ${dependiente?.ministerio}` : ''
}